import { Box, Typography } from "@mui/material";

const PostRequirementCard = ({ count, text, bgColor, color, padding }) => {
    return (
        <Box sx={{ backgroundColor: bgColor, padding: padding, color: color, borderRadius: '5px' }}>
            <Typography sx={{ fontSize: '30px', fontWeight: '700' }}>{count ? count : ''}</Typography>
            <Typography sx={{ fontWeight: '700' }}>{text ? text : ''}</Typography>
        </Box>
    )
}
export default PostRequirementCard;